import Vue from 'vue'
const EventHub = new Vue()
export default EventHub
